import React from 'react';
import Image from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby";
import styled from 'styled-components'
import { rhythm } from "../utils/typography";

import SocialIcons from "./SocialIcons";


const BioDiv = styled.div`
  width:100%;
  padding:${rhythm(0.75)};
  margin-bottom:${rhythm(8)};
  margin-top:-${rhythm(2)};
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  @media only screen and (max-width: 650px) {
    margin-bottom:${rhythm(2)};
  }
`;

const ProfileDetails = styled.div`
text-align:center;
color:var(--color-headingFont);
`;



const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/profile.jpg/" }) {
        childImageSharp {
            fluid(maxWidth: 130, maxHeight: 130,  ) {
              ...GatsbyImageSharpFluid
            }
          }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          description,
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author;
  const avatar = data?.avatar?.childImageSharp?.fluid;
  const authorSummary = author.summary;
  const description = data.site.siteMetadata?.description;
    const imgStyles = {
      objectFit: 'contain',
      borderRadius: `50%`,
      margin:0,
      width:'80px',
      height:'80px',
      marginBottom: '6px'
    }
  return (
    <BioDiv>
      <Image
        fluid={avatar}
        alt={author?.name || ``}
        imgStyle={imgStyles}
        style={imgStyles}
        placeholderStyle={imgStyles}
      />
      <ProfileDetails>
          <p>{authorSummary} {description}</p>
      </ProfileDetails>
      <div style={{
        display: "flex",
        gap: "1ch"
      }}>
      <SocialIcons />
      </div>
    </BioDiv>
  )
}


export default Bio;